/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Components, Theme } from "@mui/material/styles";

export const muiFormHelperTextStyle = (): Components<Theme>["MuiFormHelperText"] => ({
  styleOverrides: {
    contained: ({ theme }) => ({
      marginLeft: "0",
      marginRight: "0",
      [theme.breakpoints.up("sm")]: {
        marginLeft: "0.875rem",
        marginRight: "0.875rem",
      },
    }),
  },
});
